const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/planner/live/timeline/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { getItemsTreeSetQueryOptions } from '@/lib/queries/common/useGetItemsDataSetQuery';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD').optional();
const plannerTimelineSearchSchema = itemPanelSearchSchema.extend({
  from: isoDate,
  to: isoDate
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/live/timeline/')({
  loader: async ({
    params: {
      loopId
    },
    context: {
      queryClient
    }
  }) => {
    const filter = {
      loopId: {
        value: Number(loopId),
        operator: 'eq' as const
      }
    };
    await queryClient.ensureQueryData(getItemsTreeSetQueryOptions({
      filter,
      includeDescendants: true
    }));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(plannerTimelineSearchSchema),
  pendingComponent: FullSizeSpinner
});